const shouldShowProfessional = (currentUser) => {
  if (currentUser.type === "assistant") return true;

  const healthCenter = currentUser.profile?.healthCenter;
  return !!healthCenter && !healthCenter.independentDoctors;
};

export default shouldShowProfessional;
